<template>
  <xm-flex>
    <xm-flex-item><xm-total-count>{{`图文列表(${totalCount}条)`}}</xm-total-count></xm-flex-item>
    <xm-flex-item :flex="1">
      <xm-table-plus :query-data="queryData" ref="table" @cell-click="cellClick">
        <el-table-column label="图文名称">
          <template #default="scope">
            <span>{{scope.row.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="text" label="图文">
          <template #default="scope">
            <span :class="scope.row.text?'green':'red'">{{scope.row.text ?'已设置图文': '未设置'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template #default="scope">
            <el-button type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
            <el-button type="text" size="small" @click="clear(scope.row.id)" :disabled="!scope.row.text">清除</el-button>
          </template>
        </el-table-column>
      </xm-table-plus>
    </xm-flex-item>
  </xm-flex>
</template>
<script>
import axios from '@/common/utils/axios'
import { useRouter } from 'vue-router'
import { onMounted, ref } from 'vue'
import { ElTableColumn, ElButton } from 'element-plus'
export default {
  props: ['type'],

  components: {
    ElTableColumn, ElButton
  },

  setup (prop) {
    const router = useRouter()
    /**
     * 表单信息
     */
    const table = ref(null)
    const totalCount = ref(0)
    /**
     * 查询表单列表
     */
    const queryData = (page, pageSize) => {
      return new Promise((resolve) => {
        axios('/admin/desc/list', {
          type: prop.type,
          page,
          pageSize
        })
          .then(res => {
            totalCount.value = res.totalCount
            resolve({
              list: res.descList,
              totalCount: res.totalCount
            })
          }).catch(_ => { })
      })
    }
    onMounted(() => {
      table.value.reload()
    })

    /**
     * 详情跳转
     */
    const edit = (id) => {
      router.push({
        path: '/desc-template/edit',
        query: {
          id: id
        }
      })
    }
    /**
     * 清除
     */
    const clear = (id) => {
      window.$confirm('是否确认清除').then(() => {
        del(id)
      }).catch(_ => { })
    }
    const del = (id) => {
      axios('/admin/desc/del', {
        descId: id
      })
        .then(res => {
          window.$message({
            message: '操作成功',
            type: 'success'
          })
          table.value.reloadCurrent()
        }).catch(_ => { })
    }
    /**
     * 点击表格
     */
    const cellClick = (row, column, cell, event) => {
      if (column.label === '图文名称') {
        edit(row.id)
      }
    }

    return {
      table,
      totalCount,
      queryData,
      edit,
      clear,
      cellClick
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep tr td:first-child {
  cursor: pointer;
}
.green {
  color: $font-green;
}
.red {
  color: $font-red;
}
</style>
